import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-row" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("打开模态框")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "模态框内容", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hl_button = _resolveComponent("hl-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_hl_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.modalVisible = true))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_modal, {
      width: "80%",
      height: "60%",
      visible: $setup.modalVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (($setup.modalVisible) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}